import type { FC } from 'react';

import type { IconProps } from './type';

export const DarkIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.8328 9.24108C16.7452 9.17674 16.6424 9.13641 16.5345 9.1241C16.4266 9.11178 16.3173 9.12792 16.2175 9.17089C15.1838 9.61356 14.0413 9.73644 12.9371 9.52368C11.833 9.31093 10.8178 8.77231 10.0227 7.97725C9.22747 7.1822 8.68868 6.16717 8.47574 5.06305C8.26281 3.95893 8.3855 2.81633 8.82799 1.78259C8.87077 1.68274 8.88678 1.57346 8.87445 1.46554C8.86212 1.35762 8.82186 1.25477 8.75766 1.16715C8.69345 1.07953 8.60751 1.01016 8.50832 0.965885C8.40913 0.921609 8.3001 0.903956 8.19201 0.914666C6.66145 1.06769 5.20576 1.65202 3.99419 2.59972C2.78263 3.54742 1.86496 4.81956 1.34787 6.26823C0.830784 7.7169 0.735528 9.28259 1.07318 10.7833C1.41082 12.2839 2.16751 13.6579 3.25525 14.7455C4.34299 15.8331 5.7171 16.5896 7.21782 16.9271C8.71854 17.2645 10.2842 17.169 11.7328 16.6518C13.1814 16.1345 14.4534 15.2166 15.401 14.0049C16.3485 12.7932 16.9326 11.3375 17.0854 9.80688C17.0962 9.69874 17.0785 9.58966 17.0342 9.49043C16.9899 9.39121 16.9205 9.30526 16.8328 9.24108Z"
        fill="#6A73B5"
      />
    </svg>
  );
};
